export const API_URL = process.env.REACT_APP_API_URL

export const AJAX_URL_BOOKINGS = API_URL + '/bookings'
export const AJAX_URL_BOOKINGS_VIEW = API_URL + '/bookings/view'
export const AJAX_URL_BOOKING_EVENTS = API_URL + '/bookings/events'
export const AJAX_URL_BOOKING_EXPORT = API_URL + '/bookings/export'